import { string, object, bool, func, array } from 'prop-types'
import { Fragment } from 'react'
import { renderIcon, Asset } from '@opallabs/kuiper'
import { DragAndDropAssetGallery } from '../../../../../DragAndDropAssetGallery'
import { facebookStandardPositions } from '../../../../../DragAndDropAssetGallery/positions'
import { FacebookStandardHeader } from '../../FacebookStandardHeader'
import { sharedStyles } from '../shared/styles.js'
import { styles } from './styles'

export const DesktopNewsFeed = ({
  accountImage,
  accountName,
  assets,
  collabEnabled,
  collabAccount,
  content,
  isPresenting,
  linksWithData,
  onAssetChange,
  onContentChange,
  onExpandAsset,
  onLinkDataUpdate,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly,
  scheduledAt,
  timezone,
  truncate,
  updateCaption,
}) => (
  <Fragment>
    <FacebookStandardHeader
      accountImage={accountImage}
      accountName={accountName}
      collabEnabled={collabEnabled}
      collabAccount={collabAccount}
      scheduledAt={scheduledAt}
      timezone={timezone}
      onAssetChange={onAssetChange}
      onContentChange={onContentChange}
      onExpandAsset={onExpandAsset}
      onShowAssetPicker={onShowAssetPicker}
      readOnly={readOnly}
      content={content}
      truncate={truncate}
      assets={assets}
      isPresenting={isPresenting}
      onLinkDataUpdate={onLinkDataUpdate}
      onRemoveAsset={onRemoveAsset}
      linksWithData={linksWithData}
      updateCaption={updateCaption}
      display="desktopNewsFeed"
    />
    {assets.length === 1 && (
      <div style={styles.previewWrapper}>
        <Asset
          imageFit="cover"
          hasAssetOptions={true}
          hasAssetOverlay={assets[0] && (!readOnly || isPresenting)}
          assetReference={assets[0]}
          placeholder={true}
          removeable={!isPresenting}
          updateCaption={updateCaption}
          overrideStyles={{ assetBase: styles.singleAsset }}
          onEmbiggen={() => onExpandAsset(assets[0].id)}
          onRemove={() => onRemoveAsset(assets[0].id)}
        />
      </div>
    )}
    {assets.length > 1 && (
      <div style={styles.previewWrapper}>
        <DragAndDropAssetGallery
          assets={assets}
          display="facebook standard"
          galleryContainerStyles={styles.galleryContainer}
          maxAssets={5}
          maxHeight={680}
          maxWidth={680}
          hasAssetOptions={true}
          isPresenting={isPresenting}
          onAssetChange={onAssetChange}
          onExpandAsset={onExpandAsset}
          onRemoveAsset={onRemoveAsset}
          positions={facebookStandardPositions}
          readOnly={readOnly}
          updateCaption={updateCaption}
        />
      </div>
    )}
    <div style={sharedStyles.footerWrapper}>
      <ul style={styles.footer}>
        <li style={sharedStyles.footerItem}>
          {renderIcon('facebook-desktop-like-outlined', { ariaMode: 'hidden' })}
          <span style={sharedStyles.footerText}>Like</span>
        </li>
        <li style={sharedStyles.footerItem}>
          {renderIcon('facebook-desktop-message-outlined', {
            ariaMode: 'hidden',
          })}
          <span style={sharedStyles.footerText}>Comment</span>
        </li>
        <li style={sharedStyles.footerItem}>
          {renderIcon('facebook-desktop-share-outlined', {
            ariaMode: 'hidden',
          })}
          <span style={sharedStyles.footerText}>Share</span>
        </li>
      </ul>
    </div>
  </Fragment>
)

DesktopNewsFeed.propTypes = {
  accountImage: object,
  accountName: string,
  assets: array,
  collabEnabled: bool,
  collabAccount: string,
  content: string,
  isPresenting: bool,
  linksWithData: array,
  onAssetChange: func,
  onContentChange: func,
  onExpandAsset: func,
  onLinkDataUpdate: func,
  onRemoveAsset: func,
  onShowAssetPicker: func,
  readOnly: bool,
  scheduledAt: string,
  timezone: string,
  truncate: bool,
  updateCaption: func,
}
